// extracted by mini-css-extract-plugin
module.exports = {"spikexModal":"securityModals_spikexModal__nGZbO","spikexAlert":"securityModals_spikexAlert__3a4v1"};